export const courseFields = [
    {
        name: "title",
        label: "Course Title",
        section: "Course Details",
        type: "text",
        required: true,
        placeholder: "Enter course title",
        section: "Course Details",
    },
    {
        name: "description",
        label: "Description",
        type: "text",
        required: true,
        placeholder: "Enter description",
        section: "Course Details",
    },
    {
        name: "courseLevel",
        label: "Course Level",
        type: "select",
        required: true,
        options: [
            { id: "BEGINNER", value: "BEGINNER", label: "Beginner" },
            { id: "INTERMEDIATE", value: "INTERMEDIATE", label: "Intermediate" },
            { id: "ADVANCED", value: "ADVANCED", label: "Advanced" },
        ],
        section: "Course Details",
    },
    {
        name: "isActive",
        label: "Status",
        type: "select",
        required: true,
        placeholder: "Select Status",
        options: [
            { id: "true", value: "true", label: "Active" },
            { id: "false", value: "false", label: "Inactive" },
        ],
        section: "Course Details",
    },

];